export default "__VITE_ASSET__DoDCBM2c__"